const tables = [
  {
    name: "Number",
  },
  {
    name: "Request",
  },
  {
    name: "Date",
  },
  {
    name: "Issue Date",
  },
  {
    name: "Amount",
  },
 /*  {
    name: "Issue Status",
  }, */
  {
    name: "Action",
  },
];

export default tables;